import React, { useCallback, useState } from 'react'
import { MdDeleteForever } from 'react-icons/md'
import styled from 'styled-components'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import api from '../../actions/api'
import { toastError, toastSuccess } from '../../actions/toast'
import { handleError } from '../../actions/handle-error'

function DeleteLesson(props) {
  const [showModal, setShowModal] = useState(false)

  const deleteLesson = useCallback(async id => {
    await api.delete(`lessons/${id}`)
      .then(() => {
        toastSuccess(`Aula excluida!`);
        props.updateCoursePage()
        setShowModal(false)
      }).catch(error => {
        toastError(handleError(error));
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <button
        disabled={props.disabled}
        className="btn btn-sm border-danger m-1"
        onClick={() => setShowModal(true)}>
        <MdDeleteForever />
      </button>

      <Modal
        isOpen={showModal}
        wrapClassName="modal-danger"
        size="default">
        <ModalHeader >Deletar Aula</ModalHeader>
        <ModalBody>
          Deseja excluir a aula {props.name}?
        </ModalBody>
        <ModalFooter>
          <button className="btn border-danger" onClick={() => setShowModal(false)}>
            Cancelar
          </button>
          <button className="btn btn-info col-3" onClick={() => deleteLesson(props.id)}>
            Sim
          </button>
        </ModalFooter>
      </Modal>
    </>
  )
}
DeleteLesson.defaultProps = {
  id: String,
  name: String,
  updateCoursePage: Function
}

export default DeleteLesson

export const Delete = styled.div`
  svg:hover {
    width: 20px !important;
    height: 20px !important;
    color: #ab2424 !important;
    cursor: pointer;
  }
`